import { Box, Button } from "@mui/material";

const NewProjectButton = ({ onClick }) => {
  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{
          width: "150px",
          marginTop: 4,
          padding: "8px",
          fontWeight: "bold",
          backgroundColor: "$primary-color", // Azul semelhante ao da imagem
          "&:hover": { backgroundColor: "$primary-color" },
        }}
        onClick={onClick} // Chama a função passada pelo pai
      >
        NEW PROJECT
      </Button>
    </Box>
  );
};

export default NewProjectButton;
